import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Utils } from 'src/app/core/services/utils';
import { User } from 'src/app/models/user/user.model';

@Component({
    selector: 'app-select-user-modal',
    templateUrl: './select-user-modal.component.html',
    styleUrls: ['./select-user-modal.component.scss'],
    standalone: false
})
export class SelectUserModalComponent implements OnInit {

  title: string;
  users: User[] = [];

  cancelButtonText: string = "Cancel";
  submitButtonText: string = "Select";

  userId: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.users.forEach(user => {
        user['userName'] = Utils.getBorrowerFullName(user);
    });
    this.users = this.users.sort((a, b) => a.userName?.localeCompare(b.userName));
  }
}
